import { Dispatch } from '@reduxjs/toolkit';
import { AppState } from '../store';
import { IAccommodationBlocking } from '../actions/sales-configuration';

// Mirrors postAccommodationBlocking's typed-result pattern (see docs/adr/0008): nobody besides
// the page that triggered the fetch needs this result, and it shouldn't outlive that page, so
// it's returned directly from the thunk rather than dispatched into redux state.
export type GetAccommodationBlockingByIdResult =
  | { status: 'found'; blocking: IAccommodationBlocking }
  | { status: 'notFound' }
  | { status: 'failed' };

export function getAccommodationBlockingById(id: number): ReduxAction {
  return async (dispatch: Dispatch, getState: () => AppState): Promise<GetAccommodationBlockingByIdResult> => {
    const {
      general: { appConfiguration, accessToken },
    } = getState();

    try {
      const response = await fetch(
        `${appConfiguration.VITE_API_SALES_CONFIGURATION}/api/AccommodationBlocking/${id}`,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`
          },
        }
      );

      if (response.ok) {
        const blocking = (await response.json()) as IAccommodationBlocking;
        return { status: 'found', blocking };
      }

      if (response.status === 404) {
        return { status: 'notFound' };
      }

      console.error(`Unexpected response fetching Accommodation Blocking ${id}: ${response.status}`);
      return { status: 'failed' };
    } catch (error) {
      console.error(error);
      return { status: 'failed' };
    }
  };
}
